import React from "react";
import { Modal, Stack, Box } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";

import PrimaryButton from "../buttons/primary-button";
import SecondaryButton from "../buttons/secondary-button";
import Heading5 from "../typography/heading-05";
import PrintDocument from "./PrintDocument";

import styles from "./index.module.scss";
import "./mui-styles.scss";

// Standalone (not nested under quick-pricer-form) so LC-494's standalone
// Quick Pricer page can reuse this preview/print flow as-is.
const QuickPricerPrintPreview = ({
	open,
	handleClose,
	formState,
	selectedProducts,
	selectedRateKeys,
	currentUser,
	orgLabel,
	generatedAt,
	isCorrOrNdcChannel,
	isPublic,
}) => {
	const handlePrint = () => {
		window.print();
	};

	return (
		<Modal open={open} aria-labelledby="quick pricer print preview">
			<Box className={styles.previewRoot}>
				<Stack
					direction="row"
					justifyContent="space-between"
					alignItems="center"
					className={styles.toolbar}
				>
					<Heading5 text="Print Preview" fontType="semibold" />
					<Stack direction="row" spacing={2}>
						<SecondaryButton
							startIcon={<CloseIcon />}
							text="Close"
							onClick={handleClose}
						/>
						<PrimaryButton
							startIcon={<PrintOutlinedIcon />}
							text="Print / Save as PDF"
							onClick={handlePrint}
						/>
					</Stack>
				</Stack>

				<Box className={styles.documentScrollArea}>
					<PrintDocument
						formState={formState}
						selectedProducts={selectedProducts}
						selectedRateKeys={selectedRateKeys}
						currentUser={currentUser}
						orgLabel={orgLabel}
						generatedAt={generatedAt}
						isCorrOrNdcChannel={isCorrOrNdcChannel}
						isPublic={isPublic}
					/>
				</Box>
			</Box>
		</Modal>
	);
};

export default QuickPricerPrintPreview;
